var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", { staticClass: "md-layout" }, [
        _c("div", { staticClass: "md-layout-item" }, [
          _c("div", { staticClass: "custom-toolbar" }, [
            _c(
              "div",
              { staticClass: "custom-toolbar-start" },
              [
                _c(
                  "md-field",
                  { staticClass: "field-select reminder-filter-field" },
                  [
                    _c("label", [_vm._v("Filter By:")]),
                    _c(
                      "md-select",
                      {
                        on: { "md-selected": _vm.handleFilterChange },
                        model: {
                          value: _vm.reminderTypeFilter,
                          callback: function ($$v) {
                            _vm.reminderTypeFilter = $$v
                          },
                          expression: "reminderTypeFilter",
                        },
                      },
                      [
                        _c("md-option", { attrs: { value: "" } }, [
                          _vm._v("All Types"),
                        ]),
                        _c("md-option", { attrs: { value: "date" } }, [
                          _vm._v("Date"),
                        ]),
                        _c("md-option", { attrs: { value: "km" } }, [
                          _vm._v("Km"),
                        ]),
                        _c("md-option", { attrs: { value: "miles" } }, [
                          _vm._v("Miles"),
                        ]),
                        _c("md-option", { attrs: { value: "hours" } }, [
                          _vm._v("Hours"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._m(0),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
          },
          [
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  { staticClass: "md-card-header-icon md-card-header-green" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [_c("md-icon", [_vm._v("schedule")])],
                      1
                    ),
                  ]
                ),
                _c("md-card-content", { staticClass: "body-list" }, [
                  !_vm.isListLoading
                    ? _c(
                        "div",
                        [
                          _vm.sortedMaintenanceList.length > 0
                            ? _c(
                                "md-table",
                                {
                                  key: _vm.tableKey,
                                  staticClass: "context-menu-support",
                                },
                                [
                                  _c(
                                    "md-table-row",
                                    [
                                      _c("md-table-head"),
                                      _c("md-table-head", [
                                        _vm._v("Upcoming Maintenance"),
                                      ]),
                                      _c("md-table-head", [
                                        _vm._v("Asset Name"),
                                      ]),
                                      _c("md-table-head", [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              cursor: "pointer",
                                              display: "inline-flex",
                                              "align-items": "center",
                                              position: "relative",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleSort(
                                                  "reminderType"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Reminder Type\n                                        "
                                            ),
                                            _vm.sortBy === "reminderType"
                                              ? _c("md-icon", [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.sortDirection ===
                                                          "asc"
                                                          ? "arrow_upward"
                                                          : "arrow_downward"
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _c(
                                              "md-tooltip",
                                              {
                                                attrs: {
                                                  "md-direction": "top",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Click to sort " +
                                                    _vm._s(
                                                      _vm.nextReminderTypeOrder
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("md-table-head", [_vm._v("Status")]),
                                      _c("md-table-head", [_vm._v("Actions")]),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.sortedMaintenanceList,
                                    function (item, index) {
                                      return _c(
                                        "md-table-row",
                                        {
                                          key: index,
                                          class:
                                            "status-row-" +
                                            _vm.formatStatus(item.status),
                                        },
                                        [
                                          _c(
                                            "md-table-cell",
                                            {
                                              staticClass: "status-icon-column",
                                            },
                                            [
                                              _vm.formatStatus(item.status) ==
                                              "duesoon"
                                                ? _c(
                                                    "md-icon",
                                                    {
                                                      class:
                                                        "status-" +
                                                        _vm.formatStatus(
                                                          item.status
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        report_problem\n                                        "
                                                      ),
                                                      _c(
                                                        "md-tooltip",
                                                        {
                                                          attrs: {
                                                            "md-direction":
                                                              "left",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.status)
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.formatStatus(item.status) ==
                                              "overdue"
                                                ? _c(
                                                    "md-icon",
                                                    {
                                                      class:
                                                        "status-" +
                                                        _vm.formatStatus(
                                                          item.status
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        report\n                                        "
                                                      ),
                                                      _c(
                                                        "md-tooltip",
                                                        {
                                                          attrs: {
                                                            "md-direction":
                                                              "left",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.status)
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c("md-table-cell", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.maintenanceName) +
                                                "\n                                "
                                            ),
                                          ]),
                                          _c(
                                            "md-table-cell",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass: "a-link",
                                                  attrs: {
                                                    to: {
                                                      name: "Asset Details",
                                                      params: {
                                                        assetId: item.assetId,
                                                      },
                                                    },
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(item.assetName) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "md-table-cell",
                                            [
                                              _c("reminder-indicator", {
                                                key:
                                                  _vm.counter +
                                                  "-" +
                                                  item.assetMaintenanceScheduleRelationshipId,
                                                attrs: {
                                                  "maintenance-data": item,
                                                  "current-engine-hours":
                                                    _vm.reminderTypeFilter ===
                                                      "hours" ||
                                                    !_vm.reminderTypeFilter
                                                      ? item.estimatedEngineHourValue
                                                      : null,
                                                  "next-engine-hour-due":
                                                    _vm.reminderTypeFilter ===
                                                      "hours" ||
                                                    !_vm.reminderTypeFilter
                                                      ? item.nextDueEngineHours
                                                      : null,
                                                  "next-due-distance":
                                                    (_vm.reminderTypeFilter ===
                                                      "km" &&
                                                      item.odometerUnitType ===
                                                        "km") ||
                                                    (_vm.reminderTypeFilter ===
                                                      "miles" &&
                                                      item.odometerUnitType ===
                                                        "miles") ||
                                                    (!_vm.reminderTypeFilter &&
                                                      item.nextDueOdometer !=
                                                        null)
                                                      ? item.nextDueOdometer
                                                      : null,
                                                  "current-distance-reading":
                                                    (_vm.reminderTypeFilter ===
                                                      "km" &&
                                                      item.odometerUnitType ===
                                                        "km") ||
                                                    (_vm.reminderTypeFilter ===
                                                      "miles" &&
                                                      item.odometerUnitType ===
                                                        "miles") ||
                                                    (!_vm.reminderTypeFilter &&
                                                      item.estimatedOdometerValue !=
                                                        null)
                                                      ? item.estimatedOdometerValue
                                                      : null,
                                                  "repeat-interval": 1,
                                                  "next-due-date":
                                                    _vm.reminderTypeFilter ===
                                                      "date" ||
                                                    !_vm.reminderTypeFilter
                                                      ? item.nextDueServiceDate
                                                      : null,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "md-table-cell",
                                            {
                                              staticClass:
                                                "maintenance-status-container",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "custom-badge generic-badge",
                                                  class:
                                                    _vm.formatStatus(
                                                      item.status
                                                    ) + "-badge",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(item.status) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "md-table-cell",
                                            { staticClass: "action-buttons" },
                                            [
                                              _c(
                                                "complete-maintenance-schedule-button",
                                                {
                                                  attrs: {
                                                    "maintenance-data": item,
                                                    "asset-data": item.asset,
                                                  },
                                                  on: {
                                                    maintenanceCompleted:
                                                      _vm.handleCompleteSchedule,
                                                  },
                                                }
                                              ),
                                              _c(
                                                "update-maintenance-schedule-button",
                                                {
                                                  attrs: {
                                                    "maintenance-data": item,
                                                    "asset-data": item.asset,
                                                  },
                                                  on: {
                                                    maintenanceCompleted:
                                                      _vm.handleCompleteSchedule,
                                                  },
                                                }
                                              ),
                                              _c(
                                                "remove-maintenance-schedule-button",
                                                {
                                                  attrs: {
                                                    "maintenance-data": item,
                                                    "asset-data": item.asset,
                                                  },
                                                  on: {
                                                    maintenanceCompleted:
                                                      _vm.handleCompleteSchedule,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.sortedMaintenanceList.length == 0 &&
                          !_vm.isListLoading
                            ? _c("div", [
                                _c("p", { staticClass: "no-result-message" }, [
                                  _vm._v(
                                    "No results matching your search/filter could be found."
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", [
                        _c(
                          "div",
                          { staticClass: "custom-loader" },
                          [
                            _c("fade-loader", {
                              attrs: {
                                loading: _vm.isListLoading,
                                color: "#333333",
                              },
                            }),
                            _c("span", [_vm._v("LOADING")]),
                          ],
                          1
                        ),
                      ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "md-card-actions",
        {
          staticClass: "page-footer",
          attrs: { "md-alignment": "space-between" },
        },
        [
          _c("div", [
            _c("p", { staticClass: "card-category" }, [
              _vm._v(
                "Page " +
                  _vm._s(_vm.pagination.currentPage) +
                  " of " +
                  _vm._s(_vm.totalPages)
              ),
            ]),
          ]),
          _c("pagination", {
            staticClass: "pagination-no-border pagination-success",
            attrs: { "per-page": _vm.pagination.perPage, total: _vm.total },
            on: {
              "change-page": function ($event) {
                return _vm.handleChangePage($event, _vm.pagination.perPage)
              },
            },
            model: {
              value: _vm.pagination.currentPage,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "currentPage", $$v)
              },
              expression: "pagination.currentPage",
            },
          }),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "slide" } },
        [
          _vm.showSidebar
            ? _c("maintenance-schedule-sidebar", {
                attrs: { "sidebar-data": _vm.sidebarData },
                on: { closeModal: _vm.toggleSidebar },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "custom-toolbar-end" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }